import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Cases from "../pages/cases/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
